import { AxiosPromise } from 'axios';
import { IGetCoupons, ICouponReq, IGetCouponCampuses, IGetCampusCoupons, IGetStudentCoupons, IGetCampusStudents, ICampusStudentParams, IStudentCouponReq } from '../models/coupons.model';
import axios from 'axios';
import QueryString from 'qs';

const uri = '/mgmt/coupons';

export const getCoupon = (couponCode: number): AxiosPromise<IGetCoupons> => {
  return axios.get(`${uri}/${couponCode}`);
}

export const getCoupons = (): AxiosPromise<IGetCoupons> => {
  return axios.get(`${uri}/-1`);
}

export const createCoupon = (data: ICouponReq): AxiosPromise => {
  return axios.post(uri, data);
};

export const updateCoupon = (couponCode: number, data: ICouponReq): AxiosPromise => {
  return axios.put(`${uri}/${couponCode}`, data);
};

export const getCouponCampuses = (couponCode: number): AxiosPromise<IGetCouponCampuses> => {
  return axios.get(`${uri}/${couponCode}/campus`);
}

export const getCampusCoupons = (campusCode: string): AxiosPromise<IGetCampusCoupons> => {
  return axios.get(`${uri}/${campusCode}/campusCoupons`);
}

export const getStudentCoupons = (campusCode: string): AxiosPromise<IGetStudentCoupons> => {
  return axios.get(`${uri}/${campusCode}/studentsCoupons`);
}

export const getCampusStudents = (campusCode: string, params?: ICampusStudentParams): AxiosPromise<IGetCampusStudents> => {
  let _uri = `${uri}/${campusCode}/students`;
  const qsParams = QueryString.stringify(params);
  if (qsParams) _uri += `?${qsParams}`;  
  return axios.get(_uri);
}

export const createStudentCoupons = (couponCode: number, data: IStudentCouponReq): AxiosPromise => {
  return axios.post(`${uri}/${couponCode}`, data);
};
